import script from "./FreeReadingUsed.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeReadingUsed.vue?vue&type=script&setup=true&lang=js"

import "./FreeReadingUsed.vue?vue&type=style&index=0&id=99abd93c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99abd93c"]])

export default __exports__